import React from "react";
import printer from "../images/print-button.svg";

// Helper function to determine if we should use provision name
const shouldUseProvisionName = (name) => {
  const fallbackStrings = ["EuroVelo 2"];
  return (
    name &&
    fallbackStrings.some((str) =>
      name.toLowerCase().startsWith(str.toLowerCase())
    )
  );
};

class TurnByTurn extends React.Component {
  componentDidMount() {
    if (this.props.scrollSidebarTo) {
      this.props.scrollSidebarTo(0);
    }
  }

  render() {
    // Get current journey's data
    const current = this.props.currentJourney.currentJourney;
    const data = [...this.props.cycleRoutes[current].marker];
    /* NB: We've spread in to a new array here to avoid mutating cycleRoutes[current].marker
		in state when we shift the array below. We shift to remove the first item returned by the
		API, because that item is an overall journey summary and we're looking for turn by turn nav */

    data.shift();

    const endIndex = this.props.locations.length - 1;

    return (
      <div className="turn-by-turn-wrapper printable">
        <div className="sidebar-divider">
          <h3 className="divider-title">Directions</h3>
          {/* Add a button that will print the page */}
          <button
            className="turn-by-turn__print-button"
            onClick={() => {
              window.print();
            }}
          >
            <img
              className="turn-by-turn__print-button__img"
              src={printer}
              alt={`Print this page`}
            />
          </button>
        </div>

        <ul className="turn-by-turn">
          <li className="navigation-step nav-start">
            <div className="step-direction-info">
              <div className="step-turn">
                <svg className="turn-icon">
                  <use xlinkHref="#circle-bullet" />
                </svg>
              </div>
              <div className="step-name">
                <span>Start</span> {this.props.locations[0].name}
              </div>
            </div>
          </li>

          {data.map((step, i) => (
            <NavigationStep step={step["@attributes"]} key={i} />
          ))}

          <li className="navigation-step nav-end">
            <div className="step-direction-info">
              <div className="step-turn">
                <svg className="turn-icon">
                  <use xlinkHref="#circle-bullet" />
                </svg>
              </div>
              <div className="step-name">
                <span>End</span> {this.props.locations[endIndex].name}
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

/**
 * -NavigationStep-
 * Presentational component for each step of the turn by turn navigation list
 **/
const NavigationStep = ({ step }) => {
  return (
    <li className="navigation-step">
      <div className="step-direction-info">
        <div className="step-turn">
          <svg className="turn-icon">
            <use xlinkHref={`#${step.turnIcon}`} />
          </svg>
        </div>

        <div className="step-name">
          <span>{step.turn || "straight on"}</span> to{" "}
          <span>
            {shouldUseProvisionName(step.name) ? step.provisionName : step.name}
          </span>
          <span className="distance">{step.distance}m</span>
        </div>

        <div>
          <div
            className="step-provision"
            style={{ backgroundColor: `${step.color}` }}
          ></div>
        </div>
      </div>
    </li>
  );
};

export default TurnByTurn;



// WEBPACK FOOTER //
// ./src/components/TurnByTurn.js